import scrollFactory from './scroll.js';

const carouselScrollFactory = (window, $, _) => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const ACTIVE = 'active';
  const DATA_SLIDE_TO = 'data-slide-to';

  const _defaults = {
    duration: 350,
    easing: (t, b, c, d) => -c * ((t = t / d - 1) * t * t * t - 1) + b, // easeOutQuart
    vertical: false,
    step: 1,
    start: 0,
    onScroll: () => {},
  };

  const scroll = scrollFactory(window, $, _);

  const setActiveIndicator = (index, _indicators) => {
    _indicators.forEach((x) => {
      if (x) {
        $.removeClass(ACTIVE, x);
      }
    });

    if (_indicators[index]) {
      $.addClass(ACTIVE, _indicators[index]);
    }
  };

  /* return */
  return (options, container, items, left, right, indicators) => {
    const _opts = _.merge(options, _defaults);
    const lastIndex = Math.ceil(items.length / _opts.step) - 1;

    const getScroll = _opts.vertical ? $.scrollTop : $.scrollLeft;

    const scrollInstance = scroll(_opts, container, items);

    const _indicators = [];

    const onScroll = _.throttle({}, 100, () => {
      const i = scrollInstance.isAtTheEnd() ?
        lastIndex :
        scrollInstance.indexByPos(getScroll(container));
      setActiveIndicator(i, _indicators);
      _opts.onScroll(i);
    });

    const onIndicatorFactory = (to) => (e) => {
      e.preventDefault();
      scrollInstance.set(to);
    };

    const handleIndicatorClickFactory = _.memoizeWith(
        (i) => i.toString(),
        onIndicatorFactory,
    );

    const prev = (e) => {
      e.preventDefault();
      scrollInstance.prev();
    };

    const next = (e) => {
      e.preventDefault();
      scrollInstance.next();
    };

    const bindEvents = (fn) => {
      fn('click', prev, left);
      fn('click', next, right);
      if (!_.isEmpty(_indicators)) {
        fn('scroll', onScroll, container);

        _indicators.forEach((x, i) => {
          if (x) {
            // console.log(fn.toString().substring(28, 39), i, handleIndicatorClickFactory(i) === handleIndicatorClickFactory(i))
            fn('click', handleIndicatorClickFactory(i), x);
          }
        });
      }
    };

    const destroy = () => {
      bindEvents($.off);
      scrollInstance.destroy();
    };

    /* init */
    if (indicators) {
      indicators.forEach((x) => {
        _indicators[$.getAttribute(DATA_SLIDE_TO, x)] = x;
      });
      setActiveIndicator(_opts.start, _indicators);
    }

    bindEvents($.on);

    return {
      prev: scrollInstance.prev,
      next: scrollInstance.next,
      set: scrollInstance.set,
      destroy: destroy,
    };
  };
};

const carouselScrollMock = () => ({
  prev: () => {},
  next: () => {},
  set: (n) => {},
  destroy: () => {},
});

export default carouselScrollFactory;

export {carouselScrollMock};
